import { all, put, call, takeLatest } from 'redux-saga/effects';
import { addInsuredRisksToPolicy } from '../insuredRisksToPolicies/slice';
import { createPoliciesToRisks } from '../policiesToRisks/slice';
import renderNotification from '../../helpers/notifications/renderNotification';
import { NOTIFICATION_MESSAGES } from '../../localization/Notifications/dictionary';
import { renderSuccessNotificationWithRedirect } from '../../helpers/notifications/renderSuccessNotificationWithRedirect';
import { onGetRisks } from '../risks/api';
import { reloadPolicies } from '../policies/slice';
import { onGetPolicy, onCreatePolicy, onDeletePolicy, onUpdatePolicy } from './api';

import {
  getPolicy,
  getPolicySucceeded,
  getPolicyFailed,
  getConnectedRisks,
  getConnectedRisksSucceeded,
  getConnectedRisksFailed,
  createPolicy,
  createPolicySucceeded,
  createPolicyFailed,
  updatePolicy,
  updatePolicySucceeded,
  updatePolicyFailed,
  deletePolicy,
  deletePolicySucceeded,
  deletePolicyFailed
} from './slice';

const { policy_create_success, policy_delete_success } = NOTIFICATION_MESSAGES;

export function* getPolicyWorker({ payload }) {
  const { policyId } = payload;

  try {
    const response = yield call(onGetPolicy, policyId);
    yield put(getPolicySucceeded(response.data));
  } catch {
    yield put(getPolicyFailed());
  }
}

export function* getPolicyConnectedRisksWorker({ payload }) {
  const { policyId } = payload;

  try {
    const response = yield call(onGetRisks, { policy_id: policyId, paging: false });
    yield put(getConnectedRisksSucceeded(response.data));
  } catch {
    yield put(getConnectedRisksFailed());
  }
}

export function* createPolicyWorker({ payload }) {
  const { policy, insuredRisks, selectedRisks, callback, navigate } = payload;

  try {
    const response = yield call(onCreatePolicy, [policy]);
    const createdPolicy = response.data[0];
    const { id: policy_id } = createdPolicy;

    if (insuredRisks && insuredRisks.length > 0) {
      const insuredRisksToPolicy = insuredRisks.map((item) => ({
        ...item,
        policy_id
      }));
      yield put(addInsuredRisksToPolicy({ insuredRisksToPolicy }));
    }

    if (selectedRisks && selectedRisks.length > 0) {
      const policiesToRisks = selectedRisks.map((risk) => ({
        risk_id: risk.id,
        policy_id
      }));
      yield put(createPoliciesToRisks({ context: 'policy', policiesToRisks, showNotification: false }));
    }

    yield put(reloadPolicies());
    yield put(createPolicySucceeded({ policy: createdPolicy }));

    callback?.();

    renderSuccessNotificationWithRedirect(
      policy_create_success,
      'Vertrag ansehen',
      `/policy/${createdPolicy.id}/main`,
      navigate
    );
  } catch {
    yield put(createPolicyFailed());
  }
}

export function* updatePolicyWorker({ payload }) {
  const { policy, callback } = payload;

  try {
    const response = yield call(onUpdatePolicy, [policy]);
    yield put(updatePolicySucceeded(response.data[0]));
    callback?.();
  } catch {
    yield put(updatePolicyFailed());
  }
}

export function* deletePolicyWorker({ payload }) {
  const { policyId, callback } = payload;

  try {
    yield call(onDeletePolicy, [policyId]);
    callback?.();
    renderNotification({ type: 'success', message: policy_delete_success });
    yield put(deletePolicySucceeded());
  } catch {
    yield put(deletePolicyFailed());
  }
}

export default function* policySaga() {
  yield all([
    takeLatest(getPolicy.type, getPolicyWorker),
    takeLatest(getConnectedRisks.type, getPolicyConnectedRisksWorker),
    takeLatest(createPolicy.type, createPolicyWorker),
    takeLatest(updatePolicy.type, updatePolicyWorker),
    takeLatest(deletePolicy.type, deletePolicyWorker)
  ]);
}
